import { render } from "./WalletTransfersTab.vue?vue&type=template&id=3f240fe9&scoped=true"
import script from "./WalletTransfersTab.vue?vue&type=script&lang=js"
export * from "./WalletTransfersTab.vue?vue&type=script&lang=js"

import "./WalletTransfersTab.vue?vue&type=style&index=0&id=3f240fe9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f240fe9"]])

export default __exports__